import { FAQType } from './types';

// NOTE: 해당 리스트 내용 편집 필요 (디자인으로부터 발췌)
/*
export const faqList: FAQType[] = [
  {
    title: 'What is the process about IOPS SPACE?',
    description:
      'Add Spacecraft => Add Contact Profile => Setting Spacecraft and Ground Station => Check and Schedule a Contact => Receive payment request email => Receive Confirmation email after payment => take the data from Spacecraft'
  },
  {
    title: 'How to use IOPS SPACE?',
    description:
      `Please sign up for membership through the website, and then follow the steps question number 2's answer.`
  },
  {
    title: 'How can I pay?',
    description: 
    `first, when you book the schedule, we send the e-mail with payment account for remit the price\n
Seconds, you just remit the total amount, however if you not remit in 3 days, your booking is canceled.\n
Last, if you remit the all amount, we send final Confirmation note! Then your reservation is completed.`
  },
  {
    title: 'When can I take the data?',
    description:
      'A link to download satellite data will be sent to the email you signed up with. Please note that it is stored on the IOPS SPACE server for 30 days and deleted thereafter.'
  },
  {
    title: 'Can I change the confirmed schedule?',
    description:
    'Yes, you can change at any time (however, within 7 days from the registration time, orbit recalculation is required.)'
  },
  {
    title: 'What kind of transmit and receive frequency supports?',
    description:
    `Antenna Specification\n 
    •	G/T : S Band(≥ 14dB/k), X Band(≥ 27 dB/k)\n
    •	Antenna Velocity : AZ: 0.1~20°/s, EL: 0.1~20°/s Tilt: 0.1~5°/s\n
    •	Pointing Accuracy : ≤ 0.1°\n
    •	Antenna Diameter(m) : 4.5 m\n
    •	Frequency\n
     - Tx : 2025 ~ 2120 MHz\n
     - Rx : 2200 ~ 2300 MHz\n`
  },
  {
    title: 'What kind of spacecraft can contact?',
    description:
    'We optimized for LEO CubeSat but also support GEO and Deep Space satellites. Our ground station has multiple coverage.'
  },
  {
    title: 'l forgot my password.',
    description:
    'The link to change your password will be sent to the email address you provided when you signed up.'
  }
];
*/

// [FAQ 다국어 항목 리스트 생성]
// 현재 FAQ는 8개의 항목으로 구성되어 있으며,
// 각 항목의 title/description은 locales 폴더의 i18n 리소스에서 'faq.list.{index}' 경로로 정의됨.
// 예: faq.list.0.title, faq.list.0.description ~ faq.list.7.title, faq.list.7.description
//
// 확장 방법:
// - 새 항목을 추가할 경우, en/ko 각 언어 리소스의 faq.list 배열에 동일한 구조로 항목을 추가
// - 이 length 값도 항목 수에 맞게 조정해주면 자동 반영됨

export const faqList = Array.from({ length: 8 }, (_, i) => ({
  title: `faq.list.${i}.title`,
  description: `faq.list.${i}.description`
}));

/**
 // 항목 2개 더 추가 시
export const faqList = Array.from({ length: 10 }, (_, i) => ({
  title: `faq.list.${i}.title`,
  description: `faq.list.${i}.description`
}));
 */

